import store from '../store'
// import axios from 'axios'
export default function auth ({ to, next }) {
  var token = localStorage.getItem('token')
  var fullname = localStorage.getItem('fullname')
  var storage = JSON.parse(localStorage.getItem('token'))
  var components = store.state.components
  var check = false
  components.map(function (value, key) {
    if (value.path === to.path) {
      check = true
    }
  })
  if (!check && !store.state.crtlKey) {
    store.commit('SET_COMPONENTS', {
      path: to.path,
      name: to.name,
      query: { ...to.query },
      params: { ...to.params }
    })
  }
  if (storage != null) {
    store.commit('SET_FULLNAME', fullname)
    store.commit('SET_CURRENCY_SYMBOL', storage.init.currencySymbol)
    store.commit('SET_START_DATE', storage.init.startDate)
    store.commit('SET_USERID', storage.init.userId)
    store.commit('SET_ACCESS', storage.init.access)
    store.commit('SET_END_DATE', storage.init.endDate)
    store.commit('SET_FINANCIALYEAR', storage.init.financialYear)
    store.commit('SET_DATE_LOCALE', storage.init.date_locale.value)
    if (storage.init.date_locale.value === 'fa,en') {
      store.commit('SET_DATE_FORMAT', 'jYYYY/jMM/jDD')
    } else {
      store.commit('SET_DATE_FORMAT', 'YYYY/MM/DD')
      store.commit('SET_START_DATE', null)
      store.commit('SET_END_DATE', null)
    }
    store.commit('SET_CUID', localStorage.getItem('cuid'))
    store.commit('SET_RTL', storage.init.rtl.value)
    store.commit('SET_DARK', storage.init.dark.value)
    store.commit('SET_HOVERMENU', (storage.init.hoverMenu ? storage.init.hoverMenu.value : null))
    store.commit('SET_APPBARSOPACITY', (storage.init.appBarsOpacity ? storage.init.appBarsOpacity.value : null))
    store.commit('SET_LANG', storage.init.lang.value)
    store.commit('SET_BACKGROUNDIMAGE', storage.init.backgroundImage)
    store.commit('SET_BACKGROUNDCOLOR', storage.init.backgroundColor)
    store.commit('SET_THEME_COLOR', storage.init.theme_color.value)
    store.commit('SET_NEGATIVE_INVENTORY', (storage.init.negative_inventory ? storage.init.negative_inventory.value : null))
    store.commit('SET_CURRENCY', storage.init.currency)
    store.commit('SET_LOGO', storage.init.logo)
    store.commit('SET_YEAR', storage.init.year)
    store.commit('SET_ABRNAME', storage.init.abrName)
    store.commit('SET_MENU_BOOKMARK', storage.init.menuBookmark)
    store.commit('SET_TEACHERACCESS', storage.init.teacherAccess)
    // store.commit('SET_DEFAULTCUSTOMER', storage.defaultCustomer)
    store.commit('SET_SELLINVOICEWITHOUTCUSTOMER', storage.sellInvoiceWithoutCustomer)
    if (store.state.permissions && store.state.permissions.length > 0 && !store.state.permissions.includes(to.name) && to.name !== 'Dashboard') {
      return next({
        path: '/403?back=-1'
      })
    }
    if (to.name === 'invoiceCasher' || to.name === 'returnSellCasher' || to.name === 'mSell') {
      store.commit('SET_BOTTOMNAVIGATE', false)
    } else {
      store.commit('SET_BOTTOMNAVIGATE', true)
    }
  }

  if (!token) {
    // localStorage.setItem('last_path', to.path)
    if (location.host === 'abr.abriron.com' || location.host === 'abr.abriron.net' || location.host === 'localhost:8080') {
      return next({
        name: 'login',
        query: { back: -1 }
      })
    }
  }
  // if (location.host === 'localhost:8080' && to.path === '/') {
  //   return next({
  //     path: '/'
  //   })
  // } else {
  window.addEventListener('keydown', function (event) {
    if (event.ctrlKey) {
      store.commit('SET_CRTLKEY', true)
    }
  })
  window.addEventListener('keyup', function (event) {
    store.commit('SET_CRTLKEY', false)
  })
  if (store.state.crtlKey) {
    store.commit('SET_CRTLKEY', false)
    window.open(window.location.origin + '' + to.fullPath, '_blank')
  } else {
    return next()
  }
  // }
}
